<template>
    <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="isFormValidLocal">
        <v-row>
            <v-col cols="12" class="py-0">
                <cp-text-field   
                    ref="name_field"
                    autofocus
                    :label="$t('forms.TypeForm.name.label')"
                    :hint="$t('forms.TypeForm.name.hint')"
                    :placeholder="$t('forms.TypeForm.name.placeholder')"
                    required type="text"
                    :error-messages="getErrorMessages('name')"
                    v-model="value.name"
                    @input="clearErrorMessages('name')"
                    @keyup.enter="formType == 'EDIT' && $emit('triggerSubmit')"
                />
            </v-col>
            
            <v-col v-if="formType == 'CREATE'" cols="12" class="py-0">
                <cp-text-field
                    ref="key_field"
                    :label="$t('forms.TypeForm.key.label')"
                    :hint="$t('forms.TypeForm.key.hint')"
                    :placeholder="$t('forms.TypeForm.key.placeholder')"
                    required type="text"
                    :error-messages="getErrorMessages('key')"
                    v-model="value.key"
                    @input="clearErrorMessages('key')"
                    @keyup.enter="$emit('triggerSubmit')"
                />
            </v-col>
        </v-row>

        <!-- Slot para campos adicionais -->
        <slot></slot>

        <!-- Slot para botão de submit -->
        <slot name="submit"></slot>

    </v-form>
</template>

<script>
import type      from '@/models/Type'
import FormMixin from '@/mixins/FormMixin'

export default {
    name: 'TypeForm',
    mixins: [ FormMixin(type, 'name_field') ],
    props: {
        type: Object,
        formType: String
    }
}
</script>